import { CompanyData } from './company-data.interface';

export interface BillingData extends CompanyData {
  invoiceType: number;
  firstName: string;
  lastName: string;
}
